import { useMutation, useQueryClient } from '@tanstack/react-query';
import { useAuth } from './useAuth';
import { toast } from 'sonner';
import { sendNotification } from '@/lib/notifications';

export function useChallengePlayer() {
  const { profile } = useAuth();
  const queryClient = useQueryClient();

  const challengePlayer = useMutation({
    mutationFn: async ({
      challengedPlayerId,
      challengedPlayerName,
    }: {
      challengedPlayerId: string;
      challengedPlayerName: string;
    }) => {
      if (!profile?.id) throw new Error('Bạn cần đăng nhập');
      if (profile.id === challengedPlayerId) throw new Error('Bạn không thể tự thách đấu');

      await sendNotification({
        kind: 'challenge',
        target_profile_ids: [challengedPlayerId],
      });

      return { challengedPlayerName };
    },
    onSuccess: ({ challengedPlayerName }) => {
      queryClient.invalidateQueries({ queryKey: ['notifications'] });
      toast.success(`Đã gửi lời thách đấu đến ${challengedPlayerName}!`);
    },
    onError: (error: Error) => {
      toast.error(error.message || 'Không thể gửi lời thách đấu');
    },
  });

  return { challengePlayer };
}
